module.exports = __webpack_public_path__ + "img/writersblockthumb.1df75d4b.gif";